module.exports = __webpack_public_path__ + "img/minguo.26e36870.png";